// src/components/Sidebar.js
//
// Menu lateral do computador (telas com login). No celular a navegação continua
// na barra do rodapé (BottomNav). Em janelas estreitas o menu fica só com ícones.
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Package,
  ClipboardCheck,
  History,
  Scale,
  Truck,
  CirclePlay,
  CalendarCheck,
  LogOut,
} from "lucide-react";
import { logout } from "../services/auth";
import { VIDEO_TUTORIAL_URL } from "../config/tutorial";

const ITENS = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, match: ["/dashboard"] },
  { to: "/lista-produtos", label: "Produtos", icon: Package, match: ["/lista-produtos", "/cadastrar-produto", "/editar-produto", "/importar-produtos"] },
  { to: "/contar-estoque", label: "Contar estoque", icon: ClipboardCheck, match: ["/contar-estoque", "/cadastrar-produto-para-contagem", "/lista-produtos-para-contagem", "/editar-produto-para-contagem"] },
  { to: "/contagem-mensal", label: "Contagem mensal", icon: CalendarCheck, match: ["/contagem-mensal"] },
  { to: "/minhas-contagens", label: "Contagens", icon: History, match: ["/minhas-contagens", "/lista-de-compra"] },
  { to: "/cotacoes", label: "Cotações", icon: Scale, match: ["/cotacoes"] },
  { to: "/receber-mercadorias", label: "Receber mercadorias", icon: Truck, match: ["/receber-mercadorias"] },
];

// "/lista-produtos" não pode acender em "/lista-produtos-para-contagem": compara por trecho inteiro
const ativo = (pathname, match) => match.some((m) => pathname === m || pathname.startsWith(`${m}/`));

/** Iniciais do avatar: primeira letra do primeiro e do último nome ("Samuel Vitor" → "SV") */
export function iniciais(nome) {
  const partes = String(nome || "").trim().split(/\s+/).filter(Boolean);
  if (partes.length === 0) return "U";
  if (partes.length === 1) return partes[0].slice(0, 2).toUpperCase();
  return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
}

export default function Sidebar({ user }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const nome = user?.nome || user?.name || "Usuário";

  const sair = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <aside className="sidebar" aria-label="Menu principal">
      <Link to="/dashboard" className="sidebar-brand" aria-label="Estoque Contado - Dashboard">
        <img src="/logo.png" alt="" className="sidebar-logo" />
        <span className="sidebar-brand-name">Estoque Contado</span>
      </Link>

      <nav className="sidebar-nav" aria-label="Navegação principal">
        {ITENS.map(({ to, label, icon: Icon, match }) => {
          const atual = ativo(pathname, match);
          return (
            <Link key={to} to={to} className={`sidebar-item ${atual ? "is-active" : ""}`} aria-current={atual ? "page" : undefined} title={label}>
              <Icon aria-hidden="true" />
              <span className="sidebar-label">{label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="sidebar-bottom">
        {VIDEO_TUTORIAL_URL && (
          <Link to="/video-tutorial" className={`sidebar-item is-discreto ${ativo(pathname, ["/video-tutorial"]) ? "is-active" : ""}`} title="Vídeo tutorial">
            <CirclePlay aria-hidden="true" />
            <span className="sidebar-label">Vídeo tutorial</span>
          </Link>
        )}
        <div className="sidebar-user">
          <span className="sidebar-avatar" aria-hidden="true">{iniciais(nome)}</span>
          <span className="sidebar-user-text">
            <span className="sidebar-user-name" title={nome}>{nome}</span>
            {user?.email && <span className="sidebar-user-email" title={user.email}>{user.email}</span>}
          </span>
          <button type="button" className="sidebar-sair" onClick={sair} aria-label="Sair" title="Sair">
            <LogOut aria-hidden="true" />
          </button>
        </div>
      </div>
    </aside>
  );
}
